import { merge } from 'lodash';
import ValidationUtils from './ValidationUtils';
import Messages from './Messages';
import Categories from '../../components/ContactUs/ContactUsCategories.json';
import FormValidationUtils from '../../components/form/FormValidationUtils';

const shouldValidate = (category, subcategory) =>
  FormValidationUtils.shouldValidate(Categories, category, subcategory);

const ContactUsValidator = (values) => {
  const requiredFields = [{
    name: 'name',
    errorMessage: Messages.REQUIRED_NAME
  }, {
    name: 'email',
    errorMessage: Messages.REQUIRED_EMAIL
  }, {
    name: 'phone',
    errorMessage: Messages.REQUIRED_PHONE
  }, {
    name: 'message',
    errorMessage: Messages.REQUIRED_MESSAGE
  }];

  if (!shouldValidate(values.caseCategory, values.caseSubcategory)) {
    return {};
  }

  FormValidationUtils.addCustomFieldsValidation(
    Categories,
    values.caseCategory,
    values.caseSubcategory,
    requiredFields
  );

  let errors = ValidationUtils.validateRequiredFields(requiredFields, values);

  if (values.name && !ValidationUtils.isValidName(values.name)) {
    errors.name = Messages.INVALID_NAME;
  }

  if (values.email && !ValidationUtils.isValidEmailAddress(values.email)) {
    errors.email = Messages.INVALID_EMAIL;
  }

  if (values.phone && !ValidationUtils.isValidPhoneNumber(values.phone)) {
    errors.phone = Messages.INVALID_PHONE;
  }

  if (values.message && values.message.length < 5) {
    errors.message = Messages.REQUIRED_MESSAGE;
  }

  errors = merge(errors, ValidationUtils.validateRequiredFields([{
    name: 'caseCategory',
    errorMessage: Messages.REQUIRED_SELECT
  }], values));

  errors = merge(errors, ValidationUtils.validateRequiredFields([{
    name: 'caseSubcategory',
    errorMessage: Messages.REQUIRED_SELECT
  }], values));

  return errors;
};

export default ContactUsValidator;



/** WEBPACK FOOTER **
 ** ./src/common/validation/ContactUsValidator.js
 **/